const Customer = class {
    constructor(object) {
        if (object === undefined) {
            this.id = null;
            this.name = "CONSUMIDOR FINAL";
            this.identification = "9999999999";
            this.phone = "9999999999";
            this.address = "-";
            this.email = null;
        } else {
            this.id = object.id;
            this.name = object.name;
            this.identification = object.identification;
            this.phone = object.phoneNumber || object.phone;
            this.address = object.address;
            this.email = object.email;
        }
        
    }

    get isConsumidorFinal() {
        return this.name == "CONSUMIDOR FINAL" || this.identification == "9999999999"; 
    }
}

export default Customer